import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Pagination } from 'src/app/feature/result/model/pagination';
import { User } from 'src/app/shared/model/user';
import { UserApiService } from '../../service/user-api.service';
import { AlertService } from 'src/app/shared/service/alert.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserFormComponent } from './user-form/user-form.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html'
})
export class UsersComponent implements OnInit, OnDestroy {

  private subscription = new Subscription();
  public formGroup: FormGroup;

  public totalRecords: number;
  public pageSizes = [10, 15, 30, 50, 100];
  public pagination: Pagination;

  public users: Array<User>;


  constructor(
    private userApiService: UserApiService,
    private alertService: AlertService,
    private modalService: NgbModal
  ) { 
    this.pagination = {page: 1, recordPerPage: 10};
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
  
    this.initForm();
    this.onFind();
  }

  private initForm() {
    this.formGroup = new FormGroup({
      parameter: new FormControl(null)
    });
  }

  public onFind() {
    const parameter = this.formGroup.get('parameter').value;
    const sub = this.userApiService.findParameter(
      this.pagination,
      parameter
    ).subscribe(resp => {
      this.users = resp.content;
      this.totalRecords = resp.totalRecord;
    });
    this.subscription.add(sub);
  }


  public handlePageChange(event: number): void {
    this.pagination.page = event;
    this.onFind();
  }

  public handlePageSizeChange(event: any): void {
    this.pagination.page = 1;
    this.pagination.recordPerPage =event.target.value;
    this.onFind();
  }

  public onDelete(user: User) {
    this.alertService.showConfirmation('¿Está seguro que desea inactivar este regitro?').then(resp => {
      if (resp.value) {
        this.userApiService.delete(user.id).subscribe(() => {
          this.alertService.showSuccessful('El usere se ha inactivado correctamente', 'Inactivación exitosa')
          this.onFind();
        })
      }
    });
  }

  public onOpenForm(user?: User) {
    const modalRef = this.modalService.open(UserFormComponent, {
      backdrop: 'static',
      size: 'lg'
    })
    modalRef.componentInstance.user = user;
    modalRef.result.then((result) => {
      if (result) {
        this.onFind();
      }
    })
  }
}
